/**
 * @author="Walisson Rodrigo <walisson.rodrigo@sagatechbrasil.com.br>"
 * @copyright: SagaTech
 * @version: 1.0
 */
import React from "react";
import ReactDOM from "react-dom/client";
// Bootstrap CSS carregado via CDN no index.html
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
